import {BulkActionProps, DateInput, ListProps, NullableBooleanInput, NumberInput, SelectInput,} from "ra-ui-materialui";
import {useOptions} from "../../shared/hooks/useOptions";
import {getDefaultListProps, initField} from "../../shared/utils";
import {CustomList} from "../../components/CustomList";
import {PaymentScheduleDatagrid} from "./PaymentScheduleDatagrid";
import {Paper, Tab, Tabs} from "@material-ui/core";
import {useState} from "react";
import {InvoiceTimeTableListHeader} from "./InvoiceTimeTableListHeader";
import {PrintInvoiceTimeTableButtonSingleClient} from "./bulkAction/PrintInvoiceTimeTableButtonSingleClient";
import {PrintInvoiceTimeTableButton} from "./bulkAction/PrintInvoiceTimeTableButton";
import {SendInvoiceSumButton} from "./bulkAction/SendInvoiceSumButton";
import {SendInvoiceButton} from "./bulkAction/SendInvoiceButton";
import {AddPaymentStatusPayedBulkButton} from "./bulkAction/AddPaymentStatusPayedBulkButton";
import {ReferenceInputSubject} from "../../components/reference-inputs/ReferenceInputSubject";
import {
    AutocompleteArrayInput,
    AutocompleteInput,
    BooleanInput,
    ReferenceArrayInput,
    ReferenceInput
} from "react-admin";
import {ExportSelectedExcel} from "./bulkAction/ExportSelectedExcel";
import {ChangePaymentScheduleExpiredDateBulkButton} from "./bulkAction/ChangePaymentScheduleExpiredDateBulkButton";


export const BulkActions = (props: BulkActionProps & { type: string }) => {
    const {selectedIds, type} = props;
    return (
        <>
            <PrintInvoiceTimeTableButtonSingleClient ids={selectedIds} type={type}/>
            <PrintInvoiceTimeTableButton ids={selectedIds} type={type}/>
            {type === "S" && (<><SendInvoiceSumButton ids={selectedIds}/><SendInvoiceButton ids={selectedIds}/></>)}
            <AddPaymentStatusPayedBulkButton ids={selectedIds} {...props} />
            <ExportSelectedExcel ids={selectedIds} {...props} />
            <ChangePaymentScheduleExpiredDateBulkButton ids={selectedIds} {...props} />
        </>
    );
};


export const PaymentScheduleList = (props: ListProps) => {
    const {data: options} = useOptions("payment_schedule", "GET");
    const { data: optionsTerms } = useOptions("payment-terms", "GET");


    const [type, setType] = useState("T");

    const filters = options && optionsTerms ? [
            <ReferenceInput
                {...initField("company", options)}
                reference="autocomplete/accountcompany"
                className="filter-field-small"
                label="Azienda"
            >
                <AutocompleteInput optionText="label"/>
            </ReferenceInput>,
            <NullableBooleanInput
                {...initField("is_reminder", options)}
                label="Recupero crediti" alwaysOn
            />,
            <NullableBooleanInput label="Incassata" source="not_cashed"/>,
            <DateInput source="invoice_date_after" label="Data fattura dal"/>,
            <DateInput source="invoice_date_before" label="Data fattura al"/>,
            <NumberInput
                {...initField("invoice__sequence_number", options)}
                label="N° fattura"
            />,
            <NumberInput {...initField("id", options)} />,

            <ReferenceInputSubject
                filter={{type: "client"}}
                {...initField("client", options)}
                label="Cliente"
            />,
            <ReferenceInputSubject
                filter={{type: "supplier"}}
                {...initField("supplier", options)}
                label="Fornitore"
            />,
            <ReferenceInputSubject
                filter={{type: "supplier_client"}}
                {...initField("supplier_client", options)}
                alwaysOn
                label="Cliente/Fornitore"
            />,
            <ReferenceInput
                {...initField("last_payment_status__bank", options)}
                reference="autocomplete/bank"
                className="filter-field-small"
                label="Banca"
            >
                <AutocompleteInput optionText="label"/>
            </ReferenceInput>,
            <SelectInput
                {...initField("invoice__type", options, "array")}
                choices={options.invoice.children.type.choices}
                label="Tipo fattura"
                className="filter-field-small"
            />,
            <DateInput source="last_payment_status__date_after" label="Data ultimo stato dal"/>,
            <DateInput source="last_payment_status__date_before" label="Data ultimo stato al"/>,
            <DateInput
                {...initField("expiration_date_after", options)}
                label="Data scadenza dal"
            />,
            <DateInput
                {...initField("expiration_date_before", options)}
                label="Data scadenza fino al"
            />,
            <SelectInput
                choices={optionsTerms.method.choices}
                {...initField("payment_method", optionsTerms, "array")}
                label="Metodo di pagamento"
            />,
            <ReferenceArrayInput
                source="terms_description"
                label="Termini"
                reference="autocomplete/terms-description"
                className="filter-field-small"
            >
                <AutocompleteArrayInput optionText="label" />
            </ReferenceArrayInput>,
        ]
        : [];
    ;

    return options && type ? <>
            <Paper square>
                <Tabs
                    value={type}
                    indicatorColor="primary"
                    textColor="primary"
                    onChange={(e, newValue) => setType(newValue)}
                    aria-label="disabled tabs example"
                >
                    <Tab label="Tutto" value="T"/>
                    <Tab label="Attivo" value="S"/>
                    <Tab label="Passivo" value="P"/>
                </Tabs>
            </Paper>
            <CustomList
                sort={{
                    field: type === "P"
                        ? "invoice__supplier__business_name"
                        : "invoice__client__business_name",
                    order: "ASC",
                }}
                filters={filters}
                filter={type !== "T" ? {"invoice__invoice_type": type} : {}}
                {...getDefaultListProps(props)}
                bulkActionButtons={<BulkActions type={type}/>}
                topElement={
                    <InvoiceTimeTableListHeader
                        passive={type === "P"}
                        type={type}
                    />
                }
                filterDefaultValues={{not_cashed: false, company: 1}}

            >
                <PaymentScheduleDatagrid options={options} type={type}/>
            </CustomList>
        </>
        : null;
};
